import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MotionConfig } from 'motion/react';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { wsClient } from './lib/wsClient';
import './styles/theme.css';

wsClient.start();

const root = document.getElementById('root');
if (!root) throw new Error('#root fehlt in index.html');

/**
 * `reducedMotion="user"` ist der Gegenpart zur `prefers-reduced-motion`-Regel in
 * `theme.css`: die greift ausschließlich für CSS-Animationen, während Sheets,
 * Toasts und Verbindungsbanner ihre Transforms per JS setzen und die
 * Media-Query sonst schlicht ignorieren. Hier gesetzt statt in jeder
 * Komponente — es gibt keinen Fall, in dem eine davon die Einstellung
 * überstimmen dürfte.
 */
createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <MotionConfig reducedMotion="user">
        <App />
      </MotionConfig>
    </ErrorBoundary>
  </StrictMode>,
);
